import { render, staticRenderFns } from "./BuscarCreditos.vue?vue&type=template&id=2b2aa071&"
import script from "./BuscarCreditos.vue?vue&type=script&lang=js&"
export * from "./BuscarCreditos.vue?vue&type=script&lang=js&"
import style0 from "./BuscarCreditos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports